import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchAuthSession } from "aws-amplify/auth";

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  return context;
};

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    identityId: null,
    isAuthenticated: false,
    isInitialized: false,
  });

  useEffect(() => {
    const initializeAuth = async () => {
      if (typeof window === "undefined") return;

      try {
        // Fetch or create an unauthenticated Cognito session
        // This automatically creates an unauthenticated identity if one doesn't exist
        const session = await fetchAuthSession();

        setAuthState({
          identityId: session.identityId,
          isAuthenticated: !!session.tokens,
          isInitialized: true,
        });

        debugger;

        console.log("Cognito auth session initialized:", {
          identityId: session.identityId,
          authenticated: !!session.tokens,
        });
      } catch (error) {
        console.error("Error initializing auth session:", error);
        setAuthState({
          identityId: null,
          isAuthenticated: false,
          isInitialized: true,
        });
      }
    };

    initializeAuth();
  }, []);

  return (
    <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>
  );
};
